export const SuccessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.1">
        <path
          d="M16.9998 0.0246582C26.0926 0.0246582 33.4752 7.40728 33.4752 16.5C33.4752 25.5928 26.0926 32.9754 16.9998 32.9754C7.90704 32.9754 0.524414 25.5928 0.524414 16.5C0.524414 7.40728 7.90704 0.0246582 16.9998 0.0246582Z"
          fill="#00BC74"
        />
      </g>
      <path
        d="M16.9986 6.68506C22.4144 6.68506 26.8116 11.0823 26.8116 16.4981C26.8116 21.9139 22.4144 26.3111 16.9986 26.3111C11.5828 26.3111 7.18555 21.9139 7.18555 16.4981C7.18555 11.0823 11.5828 6.68506 16.9986 6.68506Z"
        fill="#00BC74"
      />
      <path
        d="M12.885 17.4516C13.8892 18.257 15.8976 19.8679 15.8976 19.8679C15.8976 19.8679 19.5881 15.7543 21.4333 13.6975"
        stroke="white"
        strokeWidth="1.95964"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
